<template>
        <div>
            <button class="btn btn-outline-primary btn-sm" @click.prevent="makeAdmin" v-if="admin === false">{{ __('globals.make_admin')}}</button>
            <button class="btn btn-outline-success btn-sm" @click.prevent="makeAdmin" v-else-if="admin === true">{{ __('globals.remove_admin')}}</button>

        </div>
</template>

<script>
    export default {
        props: ['data', 'member', 'section', 'isadmin'],
        name: "ServiceAdmin",
        data() {
            return {
                module: this.data,
                service: this.section,
                user: this.member,
                admin: this.isadmin,
                one_admin_message_message: this.__('one_admin_message'),
            }
        },
        methods: {
            makeAdmin(){
                axios.post('/member/'+this.service+'/'+this.module.slug+'/admin/'+this.member.username)
                .then(response => {
                    if (response.data.admin === 'error'){
                        let flash_data = {
                            'message': this.one_admin_message_message,
                            'level': 'danger'
                        }
                        flash(flash_data);
                    }
                    else {
                        this.admin = response.data.admin;
                    }
                });

            },

        },
    }
</script>

<style scoped>

</style>
